import {
  createCycles,
  runDestroy,
  runMount,
  runPageOut,
  runPageIn,
} from "@/modules/_";

createCycles();
runPageIn();
runMount();

// modules
import { TextAnimations } from "@/modules/text-animations";
const textAnimations = new TextAnimations();
textAnimations.init();
import { CoinsAnimation } from "@/modules/coins-animation";
const footerCoins = new CoinsAnimation('riveFooter', 'footerSection', -0.8, "top bottom", "bottom 20%")
footerCoins.init()

history.scrollRestoration = "manual";
window.scrollTo(0, 0);